import { render, staticRenderFns } from "./DodajKontrolniListIP.vue?vue&type=template&id=15156fd2&scoped=true&"
import script from "./DodajKontrolniListIP.vue?vue&type=script&lang=js&"
export * from "./DodajKontrolniListIP.vue?vue&type=script&lang=js&"
import style0 from "./DodajKontrolniListIP.vue?vue&type=style&index=0&id=15156fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15156fd2",
  null
  
)

export default component.exports